import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('@/views/Login'),
  },
  {
    path: '',
    component: () => import('@/layout/Layout'),
    children: [{
      path: 'home',
      component: () => import('@/views/Home')
    },{
      path: 'oem',
      component: () => import('@/views/Oem')
    },{
      path: 'product',
      component: () => import('@/views/Product')
    },{
      path: 'model',
      component: () => import('@/views/Model')
    },{
      path: 'version',
      component: () => import('@/views/Version')
    },{
      path: 'module',
      component: () => import('@/views/Module')
    },{
      path: 'function',
      component: () => import('@/views/Function')
    },{
      path: 'user',
      component: () => import('@/views/User')
    }]
  }
]

const router = new VueRouter({
  routes
})

export default router
